import * as i0 from '@angular/core';
import { Directive, HostBinding, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/*
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */
const sizes = {
    extraExtraLarge: 96,
    extraLarge: 64,
    large: 48,
    medium: 32,
    small: 24,
    special: 20,
    extraSmall: 16,
};
class IconSizeDirective {
    set vzcIconSize(value) {
        const size = `${sizes[value]}px`;
        this.width = size;
        this.height = size;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IconSizeDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: IconSizeDirective, selector: "[vzcIconSize], [dsIconSize]", inputs: { vzcIconSize: "vzcIconSize" }, host: { properties: { "style.width": "this.width", "style.height": "this.height" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IconSizeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[vzcIconSize], [dsIconSize]',
                }]
        }], propDecorators: { width: [{
                type: HostBinding,
                args: ['style.width']
            }], height: [{
                type: HostBinding,
                args: ['style.height']
            }], vzcIconSize: [{
                type: Input
            }] } });

/*
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */
class IconSizeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IconSizeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: IconSizeModule, declarations: [IconSizeDirective], imports: [CommonModule], exports: [IconSizeDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IconSizeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IconSizeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [IconSizeDirective],
                    exports: [IconSizeDirective]
                }]
        }] });

/*
 * Copyright © 2018-2021. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IconSizeDirective, IconSizeModule };
